import { render } from "./BlankLayout.vue?vue&type=template&id=205e1bc5"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"

import "./BlankLayout.vue?vue&type=style&index=0&id=205e1bc5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__